(function() {
  var SidebarKo,
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SidebarKo = App.loadClass('core::viewmodels/filters/Sidebar');

  exports.Keyfields_Handler = (function(superClass) {
    extend(Keyfields_Handler, superClass);

    function Keyfields_Handler(modalInstance) {
      this.modalInstance = modalInstance;
      Keyfields_Handler.__super__.constructor.apply(this, arguments);
    }

    Keyfields_Handler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/keyfields/';
      this.subHandlers = {
        'Keyfields': {
          'class': 'portal::handlers/keyfields/Keyfields_SubHandler'
        }
      };
      this.defaultSub = 'Keyfields';
      return this.loadLayout();
    };

    Keyfields_Handler.prototype.afterLoadLayout = function(selector, data) {
      var filters;
      filters = [
        {
          name: 'Region Filters',
          filters: [
            {
              name: 'years',
              display_name: 'Year',
              control_type: 'single_dropdown'
            }, {
              name: 'states',
              display_name: 'State'
            }, {
              name: 'zones',
              display_name: 'Zone'
            }, {
              name: 'zips',
              display_name: 'ZIP Code'
            }
          ]
        }, {
          name: 'Operation Filters',
          filters: [
            {
              name: 'companies',
              display_name: 'Company'
            }, {
              name: 'owners',
              display_name: 'User'
            }, {
              name: 'farms',
              display_name: 'Farm',
              "class": 'dropup'
            }, {
              name: 'fields',
              display_name: 'Field',
              "class": 'dropup'
            }
          ]
        }, {
          name: 'Key Fields Filters',
          filters: [
            {
              name: 'seed_rep',
              display_name: 'Seed Rep',
              "class": 'dropup'
            }, {
              name: 'seed_company',
              display_name: 'Seed Company',
              "class": 'dropup'
            }, {
              name: 'brands',
              display_name: 'Brand',
              "class": 'dropup'
            }, {
              name: 'status',
              display_name: 'Status',
              "class": 'dropup',
              colors: [
                {
                  key: 'Not Started',
                  color: 'red'
                }, {
                  key: 'Incomplete',
                  color: 'orange'
                }, {
                  key: 'Complete',
                  color: 'green'
                }
              ]
            }
          ]
        }
      ];
      this.sidebar = new SidebarKo(filters);
      this.filters = this.sidebar;
      ko.applyBindings(this.sidebar, $(this.layoutSelector)[0]);
      this.keyfields_subHandler = this.createSubHandler(this.defaultSub);
      if (this.keyfields_subHandler) {
        this.keyfields_subHandler.init(this.modalInstance);
      }
      this.msg = $(this.layoutSelector).find('.message_writer');
      $(this.layoutSelector).find('.apply-filters').bind('click', (function(_this) {
        return function() {
          _this.keyfields_subHandler.loader.init('Loading Key Fields...');
          return _this.keyfields_subHandler.refreshReport();
        };
      })(this));
      return $(this.layoutSelector).find('.report-applied-filters').undelegate().delegate('.applied-filter-header', 'click', function() {
        $(this).siblings('.applied-filter-value-container').slideToggle('fast');
        if ($(this).find('.caret-arrow').hasClass('caret-right')) {
          return $(this).find('.caret-arrow').removeClass('caret-right');
        } else {
          return $(this).find('.caret-arrow').addClass('caret-right');
        }
      });
    };

    return Keyfields_Handler;

  })(Handler);

}).call(this);
